// ** React Imports
import { Fragment, useRef, useEffect, useState } from 'react'
import {
  // Link, 
  useNavigate
} from "react-router-dom"

// ** Custom Components
// import Avatar from "@components/avatar"

// ** Third Party Components
import { User, Power } from "react-feather"

// ** Reactstrap Imports
import {
  UncontrolledDropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem
} from "reactstrap"

// ** Utils
import { isUserLoggedIn } from '../../../../@core/auth/utils'
import GlobalVariable from '../../../../settings/global'
import themeConfig from '../../../../configs/themeConfig'

const UserDropdown = () => {
  const navigate = useNavigate()
  const [userData, setUserData] = useState(null)


  useEffect(() => {
    if (isUserLoggedIn() !== null) {
      setUserData(JSON.parse(localStorage.getItem('userData')))
    }
  }, [])

  const [open, setOpen] = useState(false)
  const container = useRef(null)

  const handleLogout = () => {
    setOpen(false)
    window.location.href = GlobalVariable.AzureB2CLogoutUrl
    localStorage.clear()
  }

  const handleProfile = () => {
    setOpen(false)
    navigate('/my-profile')
  }

  const InitialsName = (name) => {
    const initials = name
      .split(' ')
      .map(word => word[0])
      .join('')
      .toUpperCase()

    return initials
  }

  const handleClickOutside = event => {
    if (container.current && !container.current.contains(event.target)) {
      setOpen(false)
    }
  }

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside)

    return () => {
      // clean up
      document.removeEventListener("mousedown", handleClickOutside)
    }
  })

  const handleMouseEnter = () => {
    setOpen(true)
  }

  const handleMouseLeave = () => {
    setOpen(false)
  }

  return (
    <Fragment>
      <UncontrolledDropdown tag="li" className="dropdown-user nav-item dropdown-create nav-dropdown-profile" onMouseLeave={handleMouseLeave}>
        <DropdownToggle
          href="/"
          tag="a"
          className="nav-link dropdown-user-link usericonview  userfristname"
          onClick={(e) => e.preventDefault()}
          onMouseEnter={handleMouseEnter}
        >
          <img src={themeConfig.navicons.user} alt='user' />
        </DropdownToggle>
        <span className="user-name usernamelable ">{userData && userData.firstName} <span className='d-none'>{userData && userData.lastName}</span></span>
        <DropdownMenu end className={open ? 'show dropdown-menu-profile' : 'hide dropdown-menu-profile'}>
          <DropdownItem className='dropdowntopnav'
            // tag={Link} to="/my-profile"
            onClick={handleProfile}>
            <User size={18} className="user_Profile_icon_sub" />
            <span className="align-middle Profile_lableview">My Profile</span>
          </DropdownItem>
          <DropdownItem className='dropdowntopnav' onClick={handleLogout}>
            <Power size={14} className="user_Profile_icon_sub_logout" />
            <span className="align-middle Profile_lableview">Logout</span>
          </DropdownItem>
        </DropdownMenu>
      </UncontrolledDropdown>
    </Fragment>
  )
}

export default UserDropdown
